import React, { FC, HTMLAttributes } from 'react';
import classNames from 'classnames';
import { FaIcon } from 'components/ui';
import styles from './SuccessMessage.module.scss';

export interface ISuccessMessage extends HTMLAttributes<HTMLDivElement> {
  isSuccess?: boolean;
}

const SuccessMessage: FC<ISuccessMessage> = (props) => {
  const { isSuccess, className, children } = props;
  const rootClassName = classNames(styles.root, className, {
    [styles.active]: isSuccess,
    'd-none': !isSuccess,
  });

  return (
    <div className={rootClassName}>
      <FaIcon className='mr-1' icon='check-circle' />
      <p className={styles.text}>{children}</p>
    </div>
  );
};

export default SuccessMessage;
